<script>
import CartItem from '@/models/CartItemModel'

export default {
  name: 'WithCartItem',
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {}
  },
  computed: {
    theCartItem() {
      return CartItem.query()
        .whereId(this.id)
        .with('item')
        .first()
    }, // theCartItem
  },
  render() {
    return this.$scopedSlots.default({
      theCartItem: this.theCartItem,
    })
  },
}
</script>
